import OrderIcon from '@material-ui/icons/Note';
import ProductOrderReportsList from './components/ProductOrderReportsList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.BELARUS],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  label: 'Product orders',
  subMenuName: 'reports',
};

export default {
  list: ProductOrderReportsList,
  icon: OrderIcon,
  name: 'admin/reports/product-orders',
  options,
};
